export default __webpack_public_path__ + "843d48de7f49c71199eb6d66c2273d99.svg";